// ROI calculation strategies, selected per tenant via the ConfigCat `roiStrategy` flag
// ("standard" | "incremental"). Only the ROI numerator (the incremental margin) changes between
// strategies; the investment denominator and the `/investment * 100` step are shared.

export const ROI_STRATEGIES = {
  // Standard: numerator = scenario margin - reference margin.
  standard: ({ marginEsc, marginRef }) => marginEsc - marginRef,

  // margin_esc * (1 - units_ref / units_esc); equals unit_margin * (units_esc - units_ref)
  // with unit_margin = margin_esc / units_esc. `units` are sold (sell-out) units.
  incremental: ({ marginEsc, unitsEsc, unitsRef }) =>
    unitsEsc ? marginEsc * (1 - (unitsRef || 0) / unitsEsc) : 0,
};

// Resolve the strategy key from ConfigCat features, falling back to "standard".
export const resolveRoiStrategyKey = (features) =>
  ROI_STRATEGIES[features?.roiStrategy] ? features.roiStrategy : "standard";

// Compute the ROI numerator (the incremental margin) for the given strategy.
export const roiNumerator = (strategy, params) =>
  (ROI_STRATEGIES[strategy] || ROI_STRATEGIES.standard)(params);
